export default __webpack_public_path__ + "static/media/working.c355eb1f.webp";